
import { Brain } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function PersonalityTestHistoryHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <Brain className="h-8 w-8 text-purple-600" />
        <div>
          <h1 className="text-3xl font-bold">Histórico de Testes de Personalidade</h1>
          <p className="text-gray-600">
            Acompanhe a evolução dos seus resultados ao longo do tempo
          </p>
        </div>
      </div>
      
      <Button 
        onClick={() => navigate('/testes-personalidade')} 
        className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700"
      >
        <Brain className="h-4 w-4" />
        Realizar Novo Teste
      </Button>
    </div>
  );
}
